import { useIntl } from 'react-intl';
import { SwiperSlide } from 'swiper/react';

import { useMediasInProgress } from '@/hooks/useMediasInProgress';
import { BlockMediaInProgress } from '@/modules/library/presentation/BlockMediaInProgress';
import { useMediasPrograms } from '@/modules/medias/hooks/useMediasPrograms';
import { Block, Breakpoints } from '@/types';

import { SwiperBlock } from './SwiperBlock';

export interface ProgressCarouselBlockProps {
  block: Block;
}

export const ProgressCarouselBlock = ({ block }: ProgressCarouselBlockProps) => {
  const { formatMessage } = useIntl();
  const { mediasInProgress } = useMediasInProgress(5);
  const { mediasProgramsData } = useMediasPrograms(mediasInProgress);

  const { title } = block;

  return (
    <div className="blocks">
      <h2 className="title">{title}</h2>
      <SwiperBlock
        slidesPerView={3.3}
        slidesPerGroup={3}
        spaceBetween={10}
        slidesOffsetAfter={20}
        slidesOffsetBefore={20}
        className="block-swiper"
        breakpoints={{
          [Breakpoints.Small]: {
            slidesPerView: 4.3,
            slidesPerGroup: 4,
          },
          [Breakpoints.Medium]: {
            slidesPerView: 5.3,
            slidesPerGroup: 5,
          },
          [Breakpoints.Large]: {
            slidesPerView: 6.4,
            slidesPerGroup: 6,
          },
          [Breakpoints.ExtraLarge]: {
            slidesPerView: 7.5,
            slidesPerGroup: 6,
          },
        }}
        containerRoleDescriptionMessage={formatMessage(
          { id: 'swiper.accessibility.sliderRole' },
          { title: block.title }
        )}
      >
        {mediasProgramsData?.map(({ media, program, history }) => (
          <SwiperSlide key={`home-cover_${media.UUID}`}>
            <BlockMediaInProgress
              media={media}
              lastTimeInMedia={history?.lastTimeInMedia}
              key={media.UUID}
              program={program}
              block={block}
            />
          </SwiperSlide>
        ))}
      </SwiperBlock>
    </div>
  );
};
